import {
  Container,
  H1Summary,
  SummaryContainer,
} from "components/styled-components/generic";
import { Tooltip } from "components/styled-components/tooltip";
import { disclaimerConsumption, disclaimerRange } from "constants/disclaimers";
import { FC } from "react";
import cls from "./index.module.css";

interface RangeSummaryProps {
  id: string;
  estimatedRange: number | undefined | null;
  estimatedUsage: number | undefined | null;
}

export const RangeSummary: FC<RangeSummaryProps> = ({
  id,
  estimatedRange,
  estimatedUsage,
}) => {
  return (
    <Container key={id}>
      <SummaryContainer>
        <H1Summary>
          berechneter Verbrauch:{" "}
          <div className={cls["float-subtext"]}>
            {estimatedUsage ? estimatedUsage.toLocaleString("de") : "-"} kWh/100
            km
            <Tooltip id="consumption" tip={disclaimerConsumption} />
          </div>
        </H1Summary>
        <H1Summary>
          berechnete Reichweite:{" "}
          <div className={cls["float-subtext"]}>
            {estimatedRange ? estimatedRange.toLocaleString("de") : "-"} km
            <Tooltip id="consumption" tip={disclaimerRange} />
          </div>
        </H1Summary>
      </SummaryContainer>
    </Container>
  );
};
